import { useTranslation } from "react-i18next";
import { useThemeMode } from "@context/shared/ThemeContext";
import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import Tooltip from "@mui/material/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSunBright } from "@fortawesome/pro-solid-svg-icons";

export const DarkModeButton = () => {
  const { mode, toggleMode } = useThemeMode();
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t("common.darkMode", {
        mode: t(mode === "light" ? "common.dark" : "common.light"),
      })}
    >
      <IconButton onClick={toggleMode}>
        <SvgIcon>
          <FontAwesomeIcon
            icon={mode === "light" ? faMoon : faSunBright}
          />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};
